import React from "react";
import Fox from "../../src/FoxDark.PNG";

import { fetchDataList } from "../api";
import { useQuery } from "react-query";
import BlogPost from "../components/BlogPost/BlogPost";
import Spinner from "../components/Spinner/Spinner";

function LegalNotice() {
  const { data, isLoading } = useQuery(["legal"], () => fetchDataList("legal"));

  const keyFacts = React.useMemo(() => {
    return {
      name: data?.keyword,
      description: data?.keyfact,
      logo: Fox,
    };
  }, [data]);

  if (isLoading) return <Spinner />;

  return <BlogPost data={data} meta={keyFacts} />;
}

export default LegalNotice;
